import { useTranslation } from 'react-i18next';
import DownloadDropdownButton from './DownloadDropdownButton';
import './DesktopAppPage.css';

const DesktopAppPage = () => {
  const { t } = useTranslation();

  return (
    <main className="container">
      <section className="row app-header">
        <img
          className="logo"
          alt={t('common.electricLogo')}
          src="/assets/images/logo_electric_white.png"
        />
        <p className="app-p">
          {t('desktopApp.unenrollLink')}{' '}
          <a href="/app/disconnect">{t('desktopApp.viewInstructions')}</a>
        </p>
      </section>
      <section className="app-content">
        <div className="app-download">
          <div>
            <h1 className="app-h1">{t('desktopApp.title')}</h1>
            <p className="download-app-text">{t('desktopApp.subtitle')}</p>
            <DownloadDropdownButton />
          </div>
          <div>
            <img
              alt={t('desktopApp.laptopAlt')}
              src="/assets/images/laptop-app-features.png"
            />
          </div>
        </div>
        <div className="app-benefits row">
          <div>
            <h3>{t('desktopApp.whatIsElectric.title')}</h3>
            <p>{t('desktopApp.whatIsElectric.description1')}</p>
            <p>{t('desktopApp.whatIsElectric.description2')}</p>
          </div>
          <div>
            <h3>{t('desktopApp.keyFeatures.title')}</h3>
            <ul>
              <li>
                <strong>{t('desktopApp.keyFeatures.oneClickAccess')}</strong>{' '}
                {t('desktopApp.keyFeatures.oneClickAccessDesc')}
              </li>
              <li>
                <strong>{t('desktopApp.keyFeatures.support')}</strong>
                {t('desktopApp.keyFeatures.supportDesc')}
              </li>
              <li>
                <strong>{t('desktopApp.keyFeatures.security')}</strong>{' '}
                {t('desktopApp.keyFeatures.securityDesc')}
                <br />
                <p className="small-text">
                  {t('desktopApp.keyFeatures.proPlan')}
                </p>
              </li>
            </ul>
          </div>
          <div>
            <h3>{t('desktopApp.restAssured.title')}</h3>
            <p>
              <strong>{t('desktopApp.restAssured.privacyMatters')}</strong>{' '}
              {t('desktopApp.restAssured.privacyDesc')}
            </p>
            <p>{t('desktopApp.restAssured.confidence')}</p>
          </div>
        </div>
        <div className="row">
          <img
            alt={t('desktopApp.helpfulLinks.imageAlt')}
            src="/assets/images/electric-app-window.png"
          />
          <div>
            <h1 className="app-download-h1">
              {t('desktopApp.helpfulLinks.title')}
            </h1>
            <p className="app-p">{t('desktopApp.helpfulLinks.description')}</p>
          </div>
        </div>
        <div className="row">
          <div>
            <h1 className="app-download-h1">
              {t('desktopApp.gigawatt.title')}
            </h1>
            <p className="app-p">{t('desktopApp.gigawatt.description')}</p>
          </div>
          <img
            alt={t('desktopApp.gigawatt.imageAlt')}
            src="/assets/images/gigawatt.png"
          />
        </div>
        <div className="row">
          <img
            alt={t('desktopApp.supportCenter.imageAlt')}
            src="/assets/images/support-center.png"
          />
          <div>
            <h1 className="app-download-h1">
              {t('desktopApp.supportCenter.title')}
            </h1>
            <p className="app-p">{t('desktopApp.supportCenter.description')}</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DesktopAppPage;
